import React from 'react'
import {
  PaddedAssociations,
  PaddedDate
} from 'scripts/helpers/AppHelper'

// FloatMeta displays category that is overlaying the image.
// floatmeta toggles on or off the whole component
// hideOnLarge toggles class to hide on large window sizes
export const FloatMeta = (props) => {
  const {category, floatmeta, hideOnLarge, customOnClick} = props
  if (!floatmeta) { return null }
  const cssHideOnLarge = hideOnLarge ? 'hide-on-large' : ''
  const finalProps = {
    type: 'category',
    data: category,
    containerClass: `${cssHideOnLarge} floating-badges`,
    assocClass: 'badges tags',
    truncate: false,
    limit: 1,
    customOnClick
  }
  return <PaddedAssociations {...finalProps}/>
}

// Meta will display two data, tag and date published
// can be toggeled on or off via the meta prop
export const Meta = (props) => {
  const {category, date, show, showDate = true, badgeDateHOS, customOnClick} = props
  if (show === false) { return null }
  const cssBadgeDateHOS = badgeDateHOS ? 'hide-on-small' : ''
  const assocProps = {
    type: 'category',
    data: category,
    containerClass: 'tags-container hide-on-small',
    assocClass: 'badges tags',
    truncate: false,
    limit: 1,
    customOnClick
  }
  const dateProps = {
    containerClass: 'date-time',
    date: (date * 1000)
  }
  const paddedDate = showDate ? <PaddedDate {...dateProps}/> : null
  return (<div className={cssBadgeDateHOS}>
    <div className="meta-container">
      <PaddedAssociations {...assocProps}/>
      {paddedDate}
    </div>
  </div>)
}

// FloatDate will display a floating date on the left side of the title for
// thumbnials
export const FloatDate = ({floatdate, date, hideOnLarge}) => {
  if (!floatdate) { return null }
  const hideLarge = hideOnLarge ? 'small-4 hide-on-large' : 'small-4 med-4'
  const dateProps = {
    containerClass: `col ${hideLarge} date-time`,
    date: (date * 1000)
  }
  return <PaddedDate {...dateProps}/>
}



// WEBPACK FOOTER //
// ./assets/js/components/thumbnail/helpers/ThumnailHelpers.jsx